import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import UserDetails from '../../components/user/UserDetails';
import LanguageSettings from '../../components/settings/LanguageSettings';
import PropTypes from 'prop-types';
import { Icon } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export class SettingsView extends Component {
  render() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("span", {
        className: "col-12 inline-container space-between",
        children: [/*#__PURE__*/_jsx("h1", {
          children: /*#__PURE__*/_jsx(Translate, {
            value: "user.account"
          })
        }), /*#__PURE__*/_jsx("button", {
          onClick: this.props.onCancel,
          children: /*#__PURE__*/_jsx(Icon, {
            icon: "cross",
            size: 20
          })
        })]
      }), /*#__PURE__*/_jsx("h2", {
        className: "mb-4",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "user.language"
        })
      }), /*#__PURE__*/_jsx(LanguageSettings, {}), /*#__PURE__*/_jsx("h2", {
        className: "my-4",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "user.myProfile"
        })
      }), /*#__PURE__*/_jsx(UserDetails, {
        onCloseRequest: this.props.onCancel
      })]
    });
  }
}
SettingsView.propTypes = {
  onCancel: PropTypes.func.isRequired
};
export default SettingsView;